import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../../service/service.js';
import {BillingService} from '../../../service/billing/billingService.js';
import {ElementUtil} from '../../../utils/elementUtil.js';
import {ExportUtil} from '../../../utils/exportUtil.js';
import {TimeUtil} from '../../../utils/timeUtil.js';
import {StringUtil} from '../../../utils/stringUtil.js';
import {BaseComponent} from '../../basecomponent.js';


/* global customElements */
class OrderGrid extends BaseComponent {
	
	static get properties() {
		return {
			user: {type: Boolean}
		};
	}
	
	constructor() {
		super();		
		
		var orderGrid = this;
		setTimeout(function(){
			orderGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var orderGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_ACCOUNTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddOrder();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_ACCOUNTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit Price')
					],
					listeners: {
						click: function() {							
							actionEditPrice(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'removeControl',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					theme: 'error primary',
					style: 'float: right; width: 355px;',	
					permissions: ['ADMIN_BILLING_ACCOUNTS:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Remove Products')						
					],
					properties: {
						menu: [
							{
								tag: 'vaadin-item',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:close"></vaadin-icon> Cancel Product Next Cycle',
								listeners: {
									click: function(event) {
										actionRemove(grid.selectedItems, false, false);
									}
								}
							},
							{
								tag: 'vaadin-item',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:close"></vaadin-icon> Cancel Removal Request',
								listeners: {
									click: function(event) {
										actionCancelRequest(grid.selectedItems);
									}
								}
							},
							{
								tag: 'hr'
							},
							{
								tag: 'vaadin-item',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:trash"></vaadin-icon> Remove Product Now (Re-Invoice)',
								listeners: {
									click: function(event) {
										actionRemove(grid.selectedItems, true, true);
									}
								}
							},
							{
								tag: 'vaadin-item',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:trash"></vaadin-icon> Remove Product Now (No Re-Invoice)',
								listeners: {
									click: function(event) {
										actionRemove(grid.selectedItems, false, true);
									}
								}
							}
						]
					}
				}										
			]
		});	
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column'							
			},			
			children: [	
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-width': true,
					'auto-select': true
				},
				{						
					path: 'itemDesc',
					header: 'Description',	
					resizable: true,
					'flex-grow': '1'
				},								
				{						
					path: 'billingTypeDescription',
					header: 'Billing Type',					
					resizable: true,
					width: '9em',
					renderer: function(root, column, rowData) {
						root.textContent = rowData.item.billingTypeDescription || rowData.item.billingType || '';
					}
				},		
				{						
					path: 'billingFactorTypeDescription',
					header: 'Factor Type',					
					resizable: true,
					width: '9em',
					renderer: function(root, column, rowData) {
						root.textContent = rowData.item.billingFactorTypeDescription || rowData.item.billingFactorType || '';
					}
				},
				{						
					path: 'itemEffDts',
					header: 'Effective Date',						
					width: '9em',
					resizable: true,
					renderer: function(root, column, rowData) {
						if (rowData.item.itemEffDts) {
							var date = TimeUtil.parseDate(rowData.item.itemEffDts);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						}
					}
				},
				{						
					path: 'requestCancelDts',
					header: 'Requested Cancel Date',						
					width: '9em',
					resizable: true,
					renderer: function(root, column, rowData) {
						if (rowData.item.requestCancelDts) {
							var date = TimeUtil.parseDate(rowData.item.requestCancelDts);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						} else {
							root.innerHTML = '';
						}
					}
				},
				{						
					path: 'promotionCode',
					header: 'Promotion Code',					
					resizable: true,
					width: '9em'
				},
				{						
					path: 'referralCode',
					header: 'Referral Code',					
					resizable: true,
					width: '9em'
				},
				{						
					path: 'itemPriceAmt',
					header: 'Price',					
					resizable: true,
					width: '9em',
					renderer: function(root, column, rowData) {
						root.innerHTML = StringUtil.currencyFormat(rowData.item.itemPriceAmt);
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;				
										
					//in multi-select,  it selects after the event is called; so defer this until after that
					setTimeout(function() {
						if (grid.selectedItems.length === 1) {						
							ElementUtil.query(toolbar, 'edit').disabled = false; 
							ElementUtil.query(toolbar, 'removeControl').disabled = false;
						} else if (grid.selectedItems.length > 1) {	
							ElementUtil.query(toolbar, 'edit').disabled = true; 
							ElementUtil.query(toolbar, 'removeControl').disabled = false;
						} else {						
							ElementUtil.query(toolbar, 'edit').disabled = true;
							ElementUtil.query(toolbar, 'removeControl').disabled = true;
						}
					});						
				}
			}
		});		
		
		if (orderGrid.user) {
			toolbar.classList.add('hide');
			ElementUtil.query(grid, 'selectionColumn').hidden = true;
		}
		
		var footer = ExportUtil.createExportFooter({
			grid: grid,
			itemid: 'products',
			showDetail: false
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		orderGrid.append(flexLayout);		
		
		var actionRefresh = function() {
			
			var loadMask = orderGrid.showLoading();
			BillingService.getAccountService().getOrders(orderGrid.detail.companyId)
			.then(function(orders){							
				loadMask.remove();
				grid.activeItem = null;						
				
				//unpack records
				orderGrid.orderItems = [];
				orders.forEach(function(orderFull){
					orderFull.items.forEach(function(itemFull){
						orderGrid.orderItems.push({
							companyId: orderFull.order.companyId,
							orderItemId: itemFull.item.orderItemId,
							customerOrderNo: orderFull.order.customerOrderNo,
							itemDesc: itemFull.itemDesc,
							billingType: itemFull.item.billingType,
							billingTypeDescription: itemFull.billingTypeDescription,
							billingFactorType: itemFull.price.billingFactorType,
							billingFactorTypeDescription: itemFull.billingFactorTypeDescription,
							quantityUom: itemFull.price.quantityUom,
							itemEffDts: itemFull.item.itemEffDts,
							requestCancelDts: itemFull.item.requestCancelDts,
							promotionCode: itemFull.item.promotionCode,
							referralCode: itemFull.item.referralCode,
							itemPriceAmt: itemFull.price.itemPriceAmt,
							productCode: itemFull.item.productCode,
							featureProductCode: itemFull.item.featureProductCode,
							key: itemFull.key
						});
					});					
				});				
				
				grid.items = orderGrid.orderItems.slice(0);
			});
		};
		actionRefresh();
		
		var actionAddOrder = function() {
			
			var orderWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add Product Order',
				icon: 'lumo:edit',
				width: .75,
				height: 600,
				listeners: {
					ready: function() {						
						orderWin.show();
										
						
						var newOrderFormPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemId: 'newFormPanel',
							children: [
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'vaadin-combo-box',
											label: 'Promotion Code',
											name: 'promotionCode',
											'item-value-path': 'promotionCode',
											'item-label-path': 'promotionDesc',
											postinit: function (combo) {
												BillingService.getBundlePromotionService().getPromotions().then(function (promotions) {
													combo.items = promotions.data;
												});
											}
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Referral Code',
											name: 'referralCode',
											'item-value-path': 'referralCode',
											'item-label-path': 'referralCode',
											postinit: function (combo) {
												BillingService.getReferralService().getReferrals().then(function (referrals) {
													combo.items = referrals.data;
												});
											}
										}
									]
								}
							]							
						});						
						
						var orderToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [										
								{
									tag: 'dl-action-button',
									itemid: 'add',
									theme: 'primary',
									'class': 'spacer-toolbar-item',
									permissions: ['ADMIN_BILLING_ACCOUNTS:WRITE'],
									children:[
										ElementUtil.makeIcon('vaadin:plus', ' Add')
									],
									listeners: {
										click: function() {							
											actionAddProduct();
										}
									}					
								},
								{
									tag: 'dl-action-button',
									itemid: 'delete',
									theme: 'error primary',
									style: 'float: right;',	
									'class': 'spacer-toolbar-item',
									permissions: ['ADMIN_BILLING_ACCOUNTS:DELETE'],
									children:[
										ElementUtil.makeIcon('vaadin:trash', ' Remove')
									],
									listeners: {
										click: function() {							
											actionRemoveNewProduct(newOrderGrid.selectedItems[0]);
										}
									}
								}			
							]
						});	
						
						var orderSaveToolbar = ElementUtil.create({
							tag: 'div',
							style: 'text-align: center;',
							slot: 'footer',
							defaults: {
								tag: 'vaadin-button'
							},
							children: [
								{
									theme: 'primary',									
									children: [
										ElementUtil.makeIcon('vaadin:warning', 'Apply Now')
									],
									listeners: {
										click: function() {															
											saveNewOrder(false);
										}
									}
								},
								{
									theme: 'primary',
									style: 'margin-left: 10px;',
									children: [
										ElementUtil.makeIcon('vaadin:arrow-circle-right', ' Next Cycle')
									],
									listeners: {
										click: function() {															
											saveNewOrder(true);
										}
									}
								},
								{
									theme: 'tertiary',
									innerHTML: 'Cancel',
									style: 'margin-left: 10px;',
									listeners: {
										click: function() {
											//cancel
											orderWin.close();
										}
									}
								}
							]						
						});	
						
						var saveNewOrder = function(nextCycle) {
							
							if (newProducts.length > 0) {
								var orderData = newOrderFormPanel.getData();
								
								var newOrder = {
									promotionCode: orderData.promotionCode,										
									referralCode: orderData.referralCode,
									accountItemViews: []
								};
								
								newProducts.forEach(function(product){
									newOrder.accountItemViews.push({
										productCode: product.productCode,
										featureCode: product.featureProductCode,
										amount: product.itemPriceAmt
									});
								});
								
								var options = {
									nextCycle: nextCycle
								};
								
								var loadMask = window.DL.MessageUtil.fullPageLoadMask();
								BillingService.getAccountService().saveNewOrder(orderGrid.detail.companyId, newOrder, options)
								.then(function(){
									loadMask.opened = false;
									
									window.DL.MessageUtil.showToast('Success', 'Saved Order', {
										theme: 'success',
										position: 'top-stretch'
									});	
									actionRefresh();
									orderWin.close();
								})
								.catch(function(){
									loadMask.opened = false;
								});
								
							} else {
								window.DL.MessageUtil.showToastError('Must add at least one product.', 'Validation Error');
							}
							
						};						
						
						var newProducts = [];
						var newOrderGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},			
							children: [									
								{						
									path: 'itemDesc',
									header: 'Description',								
									'flex-grow': '1'
								},																
								{						
									path: 'itemPriceAmt',
									header: 'Price',													
									width: '9em',
									renderer: function(root, column, rowData) {
										root.innerHTML = StringUtil.currencyFormat(rowData.item.itemPriceAmt);
									}
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									newOrderGrid.selectedItems = item ? [item] : [];
									if (newOrderGrid.selectedItems.length > 0) {	
										ElementUtil.query(orderToolbar, 'delete').disabled = false; 									
									} else {															
										ElementUtil.query(orderToolbar, 'delete').disabled = true;
									}	
								}
							}
						});		

						var toolbarFormContainer = ElementUtil.create({
							tag: 'div',
							slot: 'toolbar',
							children: [
								newOrderFormPanel,
								ElementUtil.create({
									tag: 'hr'
								}),
								orderToolbar
							]
						});	

						var orderFlexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								toolbarFormContainer,
								newOrderGrid,
								orderSaveToolbar
							]
						});		
						
						orderWin.addToContentElement(orderFlexLayout);	

						var actionAddProduct = function() {
							var addWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Add Product',
								icon: 'lumo:edit',
								width: 600,
								height: 400,
								listeners: {
									ready: function() {						
										addWin.show();
										
										var formPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',										
													children: [																				
														{
															tag: 'vaadin-combo-box',											
															itemid: 'productItem',
															label: 'Product', 
															name: 'productCode',
															required: true,														
															'item-value-path': 'code',
															'item-label-path': 'itemDesc',
															postinit: function(combo) {

																BillingService.getProductService().getEffectiveProductItems().then(function(data){
																	
																	//existing
																	var products = newProducts.concat(orderGrid.orderItems);
																	
																	//format the code
																	var productItems = [];
																	data.forEach(function(item){																		
																		var productItem = item.productItem;
																		productItem.code = productItem.productItemPK.productCode + "-" + productItem.productItemPK.featureProductCode;
																		productItem.productItemPrices = item.productItemPrices;
																		
																		
																		var alreadyHasItem = false;																																			
																		products.forEach(function(existingItem){
																			if (existingItem.productCode === productItem.productItemPK.productCode &&
																				existingItem.featureProductCode === productItem.productItemPK.featureProductCode) {

																				alreadyHasItem = true;
																			}																			
																		});

																		if (!alreadyHasItem) {
																			productItems.push(productItem);
																		}
																	});
																	productItems.sort(function(a, b){
																		var codeCompare = a.code.localeCompare(b.code);
																		return codeCompare === 0 ? a.itemDesc.localeCompare(b.itemDesc) : codeCompare;
																	});

																	combo.items = productItems;
																});
															}
														},
														{
															tag: 'vaadin-number-field',
															label: 'Price',
															name: 'itemPriceAmt',
															required: true,
															min: -9999999,
															max: 9999999
														},									
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function() {															

																			var data = formPanel.getData();
																			var productSelection = ElementUtil.query(formPanel, 'productItem').selectedItem;
																			data.itemDesc = productSelection.itemDesc;
																			data.productCode = productSelection.productItemPK.productCode;
																			data.featureProductCode = productSelection.productItemPK.featureProductCode;																			
																			
																			newProducts.push(data);
																			actionRefreshNewOrderGrid();
																			addWin.close();

																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			//cancel
																			addWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]

										});
										addWin.addToContentElement(formPanel);	
										
									}
								}
							});
						};
						
						var actionRefreshNewOrderGrid = function() {
							newOrderGrid.items = newProducts.slice(0);
						};
						
						var actionRemoveNewProduct = function(toBeRemoved) {
							var newItems = [];
							newProducts.forEach(function(product){
								if (product.productCode !== toBeRemoved.productCode &&
									product.featureProductCode !== toBeRemoved.featureProductCode) {
									newItems.push(product);
								}
							});
							newProducts = newItems.slice(0);
							actionRefreshNewOrderGrid();
						};
											
					}
				}
			});
		
						
		};
		
		var actionEditPrice = function(record) {
			
			var editWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Edit Item',
				icon: 'lumo:edit',
				width: 600,
				height: 350,
				listeners: {
					ready: function() {						
						editWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [																														
										{
											tag: 'vaadin-number-field',
											label: 'Price',
											name: 'itemPriceAmt',
											required: true,
											min: -9999999,
											max: 9999999
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Promotion Code', 
											name: 'promotionCode',
											'item-value-path': 'promotionCode',
											'item-label-path': 'promotionDesc',											
											postinit: function(combo) {
												BillingService.getBundlePromotionService().getPromotions().then(function(promotions){
													combo.items = promotions.data;
												});
											}
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Referral Code', 
											name: 'referralCode',
											'item-value-path': 'referralCode',
											'item-label-path': 'signupName',																									
											postinit: function(combo) {
												BillingService.getReferralService().getReferrals().then(function(referrals){
													combo.items = referrals.data;
												});
											}
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																														
															formPanel.submitForm({
																preSubmit: function(data) {	
																																	
																	var orderItem = {
																		item: {
																			orderItemId: record.orderItemId,
																			customerOrderNo: record.customerOrderNo,																		
																			promotionCode: data.promotionCode,
																			referralCode: data.referralCode,
																			productCode: record.productCode,
																			featureProductCode: record.featureProductCode,
																			billingType: record.billingType,
																			itemEffDts: record.itemEffDts
																		},
																		price: {
																			customerOrderItemId: record.orderItemId,
																			billingFactorType: record.billingFactorType,
																			itemQuantity: 1,
																			quantityUom: record.quantityUom ? record.quantityUom : 'EA',
																			itemPriceAmt: data.itemPriceAmt,
																			currencyCode: 'USD',
																			contractPricingFlag: false,
																			overridePriceFlag: true
																		}															
																	};
																	return orderItem;
																},
																actualCall: function(data) {																	
																	return BillingService.getAccountService().updateOrderItem(
																			record.companyId, 
																			record.customerOrderNo, 
																			record.orderItemId, 
																			data
																	);																	
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Update Product Item', {
																		theme: 'success',
																		position: 'top-stretch'
																	});																	
																	actionRefresh();
																	editWin.close();
																}
															});
															

														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															editWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						editWin.addToContentElement(formPanel);							
						
					}
				}
			});
			
			
		};
				
		var actionCancelRequest = function(records) {
			
			var companyId;
			var customerOrderNo;
			var orderItemsToRemove = {
				ids: []
			};
			records.forEach(function(record) {
				if (!companyId) {
					companyId = record.companyId;
				}
				
				if (!customerOrderNo) {
					customerOrderNo = record.customerOrderNo;
				}	
				
				orderItemsToRemove.ids.push(
					record.orderItemId
				);
			});
		
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Removal',
				message: 'Are you sure you want to cancel removal request on the selected items?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing Cancel Request...');													
																					
							BillingService.getAccountService().removeCancelRequestOnOrderItems(
								companyId, 
								customerOrderNo, 
								orderItemsToRemove
							).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed cancellation', {									
									theme: 'success'
								});
								actionRefresh();
							}, function(){
								loadMask.remove();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});			
		};				
		
		var actionRemove = function(records, reInvoice, applyNow) {
			var invoiceMessage = reInvoice ? ' (Re-Invoice)' : ' ';
			var removeMessage = applyNow ? ' remove NOW ' : ' cancel next cycle ';
			
			var companyId;
			var customerOrderNo;
			var orderItemsToRemove = [];
			records.forEach(function(record) {
				if (!companyId) {
					companyId = record.companyId;
				}
				
				if (!customerOrderNo) {
					customerOrderNo = record.customerOrderNo;
				}	
				
				orderItemsToRemove.push({
					productCode: record.productCode,
					featureProductCode: record.featureProductCode,
					key: record.key
				});
			});
		
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Removal',
				message: 'Are you sure you want to' + removeMessage + ' selected items ' + invoiceMessage + '?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');													
							
							var options = {
								applyImmediately: applyNow,
								noReinvoice: !reInvoice
							};
							
							BillingService.getAccountService().deleteOrderItems(
								companyId, 
								customerOrderNo, 
								orderItemsToRemove,
								options
							).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed product(s)', {									
									theme: 'success'
								});
								actionRefresh();
							}, function(){
								loadMask.remove();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});				
		};

	}
	
};
customElements.define('dl-account-order-grid', OrderGrid);
